module.exports = function() {
  return new Worker(__webpack_public_path__ + "40d3cbcce013e03cfd61.worker.js");
};